<template  >
<CustomerLogin/>
</template>

<script>
import CustomerLogin from './components/CustomerLogin.vue'
import Vue from 'vue'

export default {
  name: 'App',
  data() {
    return {
      isRtaWebChatBot: Vue.prototype.$RtaWebChatBot
    }
  },
  components: {
    CustomerLogin

  }
}
</script>